import { Box, Stack } from '@dtx-company/design-system/src'
import { LoggedOutGeneratorSection } from '../LoggedOutCodeGenerator.types'
import { selectSection } from '@app/code/src/machines/locg/locgSelectors'
import { useGlobalServices } from '@app/common/src/hooks/useGlobalServices'
import { useSelector } from '@xstate/react'
import React from 'react'

const SCROLL_INDICATOR_SECTIONS = [
  LoggedOutGeneratorSection.ScanDestination,
  LoggedOutGeneratorSection.ColorSelector,
  LoggedOutGeneratorSection.ShapeSelector,
  LoggedOutGeneratorSection.FrameAndText,
  LoggedOutGeneratorSection.Logo
]

const CONTAINER_HEIGHT = 28.75
const SCROLL_INDICATOR_HEIGHT = 1.75

export const VerticalScrollProgress: React.FC = () => {
  const { locgService } = useGlobalServices()
  const activeSection = useSelector(locgService, selectSection)
  const index = SCROLL_INDICATOR_SECTIONS.findIndex(section => section === activeSection)
  const fullHeight = useSelector(
    locgService,
    state => state.matches('auth') || state.matches('codeDesign.complete')
  )

  return (
    <Box
      sx={theme => ({
        position: 'absolute',
        right: 0,
        zIndex: 10,
        paddingRight: '5px',
        top: '20vh',
        display: {
          xs: 'none',
          lg: 'block'
        },
        height: theme.spacing(CONTAINER_HEIGHT)
      })}
    >
      <Stack
        sx={theme => ({
          position: 'relative',
          justifyContent: 'space-between',
          ':after': {
            position: 'absolute',
            content: "''",
            inset: 0,
            height: fullHeight
              ? '100%'
              : `calc(${index} * (${theme.spacing(CONTAINER_HEIGHT)}/${
                  SCROLL_INDICATOR_SECTIONS.length
                }) + ${theme.spacing(SCROLL_INDICATOR_HEIGHT)})`,
            transition: 'height 0.2s ease-in-out',
            backgroundColor: 'text.secondary',
            borderRadius: theme.spacing(2.5)
          }
        })}
        gap={4}
      >
        {SCROLL_INDICATOR_SECTIONS.map(key => {
          return (
            <Box
              key={key}
              sx={theme => ({
                width: theme.spacing(SCROLL_INDICATOR_HEIGHT),
                height: theme.spacing(SCROLL_INDICATOR_HEIGHT),
                backgroundColor: 'onSurface.inverseSecondary',
                borderRadius: '50%'
              })}
            />
          )
        })}
      </Stack>
    </Box>
  )
}
